import { UUID } from "crypto";
import { ProcessStatus } from "../models";

export enum StudyType {
  QUALITATIVE = "QUALITATIVE",
  QUANTITATIVE = "QUANTITATIVE",
}

export enum StudyStatus {
  // Not shown in FE, shown between pages 2 and 3
  GATHERING_INPUTS = "GATHERING_INPUTS",

  // Shown as PROCESSING in the Frontend
  TRANSCRIBING = "TRANSCRIBING",

  // Shown on FE as "WAITING FOR MORE"
  ALL_AUDIO_TRANSCRIBED = "ALL_AUDIO_TRANSCRIBED",

  // Shown on FE as "READY TO CHAT"
  PUBLISHED = "PUBLISHED",

  // Emitted by Airflow job
  RUNNING_ETL = "RUNNING_ETL",
  ETL_ERROR = "ETL_ERROR",
}

export enum FileType {
  DISCUSSION_GUIDE = "DISCUSSION_GUIDE",
  AUDIO = "AUDIO",
  TRANSCRIPT = "TRANSCRIPT",
  STUDY_SUMMARY = "STUDY_SUMMARY",
  SCREENER_GUIDE = "SCREENER_GUIDE",
  SCREENER_SUMMARY = "SCREENER_SUMMARY",
  POWERPOINT = "POWERPOINT",
}

export type AudioAssignment = {
  audio_file_id: string;
  respondent_ids: string[];
  deepsense_file_guid?: UUID;
};

export type SaveStudy = {
  study_name?: string;
  study_type?: StudyType;
  study_status?: StudyStatus;
  start_date?: string; // datetime
  end_date?: string; // datetime

  vendor?: string; // Vendor Display Name
  product?: string; // Product Display Name
  therapeutic_area?: string; // Therapeutic Area Display Name

  owner?: string; // USIX ID ex: Leibniz3
  editors?: string[]; // USIX ID ex: Leibniz3

  // EditInterviewStudyRequest
  screener_summary_guid?: UUID;
  screener_guide_guid?: UUID;
  discussion_guide_guid?: UUID;
  audio_assignments?: AudioAssignment[];

  // EditPresentationStudyRequest
  power_point_guid?: UUID;
};

export type FileEditState = {
  file_type: FileType;
  file?: File;

  uploaded_file_guid?: UUID;
  s3_file_location?: string;
  original_name?: string;

  /** This should be set when file_type == "AUDIO" */
  audio_file_id?: string;
  /** Audio Process Status */
  process_status?: ProcessStatus;

  uploadProgress?: number;
};

export type VerificationResponse = {
  error_messages?: string[];
  audio_respondents: AudioAssignment[];
};
